import { useCallback } from 'react';
import { useSearchParams, type NavigateOptions, type URLSearchParamsInit } from 'react-router-dom';

type Next = URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit);

/**
 * `useSearchParams`, except that a functional update starts from the URL as it is NOW. react-router hands the callback
 * the params of the render that created the setter, so two writes close together (a debounced search, then a filter
 * picked before the page re-rendered) made the second one undo the first: a chip that vanished. Every URL-state hook
 * of the app uses this one.
 */
export function useLiveSearchParams() {
  const [params, set] = useSearchParams();
  const setParams = useCallback((next: Next, opts?: NavigateOptions) => set(typeof next === 'function' ? () => next(new URLSearchParams(window.location.search)) : next, opts), [set]);
  return [params, setParams] as const;
}
